import { ResultadoController } from 'app/_models/global/resultado-controller';

export class CaminhoImagem extends ResultadoController {
    caminhoImagem: string;
}
